import { DynamicFormFieldKey, FormFieldKey } from 'src/app/@shared/form/form.types';
import { OrganizationSubTypeForm } from '@api/organization/@shared/organization.entity';

export type DetailContentKey =
  'otherAddress' |
  'person' |
  'selfHelpAddressBa' |
  'selfHelpAddressOther' |
  OrganizationSubTypeForm |
  'cluster' |
  'topic' |
  'user';

export type DetailItemKey = DynamicFormFieldKey | FormFieldKey;
export type DetailVisibilityMode = 'all' | 'public';

export type ItemHrefType = 'url' | 'email';

export const DETAIL_VISIBILITY_MODE_KEY = 'dataVisibility';
export const TRANSPARENCY_LABEL_URL = 'https://www.nakos.de/adressen/gruen/kennzeichnung/';
export const HTML_TO_TEXT_FIELDS: DetailItemKey[] = ['description', 'notes'];

export const CUSTOM_DETAIL_FIELD_LABELS: Partial<Record<DetailItemKey, string>> = {
  file: 'FORM.LIST.TITLE.FILE_UPLOAD',
  transparencyPdf: 'FORM.LIST.TITLE.TRANSPARENCY',
};

export type DetailIconGroup = {
  fieldIds: DetailItemKey[];
  iconName: string;
};

// Only the first rendered field in each group's priority order receives its icon.
export const CONTACT_DETAIL_ICON_GROUPS: DetailIconGroup[] = [
  {
    fieldIds: [
      'name',
      'shortName',
      'addressCo',
      'addressStreetAndNumber',
      'addressPostalCode',
      'addressCity',
      'addressFederalState',
    ],
    iconName: 'location-outline',
  },
  {
    fieldIds: ['email'],
    iconName: 'mail-outline',
  },
  {
    fieldIds: ['emails'],
    iconName: 'mail-outline',
  },
  {
    fieldIds: ['emailsExtended'],
    iconName: 'mail-outline',
  },
  {
    fieldIds: ['media'],
    iconName: 'document-text-outline',
  },
  {
    fieldIds: ['person'],
    iconName: 'person-outline',
  },
  {
    fieldIds: ['phoneContacts'],
    iconName: 'call-outline',
  },
  {
    fieldIds: ['phoneNumber'],
    iconName: 'call-outline',
  },
  {
    fieldIds: ['phoneNumbers'],
    iconName: 'call-outline',
  },
  {
    fieldIds: ['qualifications'],
    iconName: 'pricetags-outline',
  },
  {
    fieldIds: ['socialMediaLinks'],
    iconName: 'share-social-outline',
  },
  {
    fieldIds: ['websites'],
    iconName: 'globe-outline',
  },
  {
    fieldIds: ['hiddenFields'],
    iconName: 'eye-off-outline',
  },
];

// fields like 'id' should already be hidden by inputType="hidden"
export const HIDDEN_FIELDS: DetailItemKey[] = ['type', 'subType', 'subTypeForm'];

// Public contact-via information is rendered in the c/o detail fieldset instead.
export const HIDDEN_FIELDS_ON_PUBLIC_ACCESS: DetailItemKey[] = [
  'localContactPoint',
  'contactOrganizationFreeText',
  'contactOrganization',
  'providerFreeText',
  'provider',
];

export const HIDDEN_FIELDS_BY_TYPE: { [key in DetailContentKey]: DetailItemKey[] } = {
  cluster: [],
  otherAddress: [],
  person: ['legacyId'],
  selfHelpAddressBa: [],
  selfHelpAddressCommunity3a: [],
  selfHelpAddressCommunity3b: [],
  selfHelpAddressCommunity3c: [],
  selfHelpAddressGa2a: [],
  selfHelpAddressGa2b: [],
  selfHelpAddressGa2c: [],
  selfHelpAddressGa2d: [],
  selfHelpAddressOther: [],
  selfHelpAddressRa1a: [],
  selfHelpAddressRa1b: [],
  selfHelpAddressRa1c: [],
  selfHelpAddressRa1d: [],
  selfHelpAddressShGroup4a: [],
  selfHelpAddressShGroup4b: [],
  selfHelpAddressShGroup4c: [],
  topic: [],
  user: [],
};

export const HREF_LINKS: {[key in ItemHrefType]?: DetailItemKey[] } = {
  email: ['email', 'emails'],
  url: ['websites', 'socialMediaLinks'],
};
